'use client';

import clsx from 'clsx';
import { Button } from 'ui';
import { Media } from '../Media/Media';
import { getCtaLink } from '../../utils/homepageLinks';
import type { ComponentMultimediaHeroCta } from '@/graphql/generated/types';
import Link from '@/components/Link';

const MultimediaHeroCTA = ({
  headingText,
  subtitleText,
  badgeText,
  ctasCollection,
  landscapeMedia,
  mediaShadow,
}: ComponentMultimediaHeroCta): JSX.Element => {
  return (
    <div className='relative h-[80vh] w-full text-white'>
      <div
        className={clsx(
          'absolute inset-0 h-full w-full',
          mediaShadow &&
            'after:absolute after:inset-0 after:bg-black/20 after:content-[""]',
        )}
      >
        <Media
          alt={landscapeMedia?.description ?? ''}
          className='absolute inset-0 h-full w-full object-cover'
          src={landscapeMedia?.url ?? ''}
        />
      </div>

      <div className='absolute inset-0 z-10 flex h-full w-full flex-col items-center justify-center gap-6'>
        {badgeText ? (
          <div className='rounded border-2 border-white bg-transparent px-3 py-2 text-sm font-bold sm:px-4 sm:py-3 sm:text-lg'>
            {badgeText}
          </div>
        ) : null}

        <div className='flex max-w-[60%] flex-col gap-6 text-center'>
          <h1 className='m-0 text-2xl font-bold normal-case leading-8 tracking-normal sm:text-[64px] sm:leading-[68px]'>
            {headingText}
          </h1>
          {subtitleText ? (
            <h2 className='m-0 text-base font-medium normal-case leading-[22px] tracking-normal sm:text-lg sm:font-semibold sm:leading-normal'>
              {subtitleText}
            </h2>
          ) : null}
        </div>

        <div className='flex flex-row gap-6'>
          {ctasCollection?.items?.map((cta) => {
            const link = getCtaLink(cta);
            if (!link) return null;
            return (
              <Button
                asChild
                className='text-xs'
                key={link}
                size='medium'
                variant='shop'
              >
                <Link href={link}>{cta?.text}</Link>
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MultimediaHeroCTA;
